import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { Box } from '@mui/material';
import React from 'react';
import { Button } from 'react-bootstrap';

interface SkipButtonProps {
  className?: string;
  onSkip: () => void;
}

const SkipButton: React.FC<SkipButtonProps> = ({ className = '', onSkip }) => {
  const { t } = useTranslationWithPrefix('views.process.quizQuestions.buttons');

  return (
    <Box className="flex justify-content-end w-100 position-absolute top-0 p-3">
      <Button
        className={`no-focus-styles bg-white border-2 border-black fw-semibold ${className} text-black`}
        onClick={onSkip}
        style={{
          fontSize: '0.875rem',
          padding: '10px 20px',
          zIndex: 9999,
        }}
      >
        {t('skip')}
      </Button>
    </Box>
  );
};

export default SkipButton;
